import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaInstagram, FaFacebook, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background: ${({ theme }) => theme.colors.secondary};
  padding: 4rem 0 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.light};
`;

const FooterLinksContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0 2rem;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const FooterLinksWrapper = styled.div`
  display: flex;
  margin: 1rem 0;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 1rem 2rem;
  width: 200px;
  
  @media screen and (max-width: 768px) {
    align-items: center;
    margin: 1rem 0;
    width: 100%;
  }
`;

const FooterLinkTitle = styled.h3`
  color: ${({ theme }) => theme.colors.highlight};
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.light};
  text-decoration: none;
  margin-bottom: 0.8rem;
  font-size: 1rem;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    color: ${({ theme }) => theme.colors.highlight};
    transform: translateX(5px);
  }
`;

const SocialMedia = styled.section`
  max-width: 1200px;
  width: 100%;
`;

const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 2rem auto 0 auto;
  padding: 0 2rem;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const SocialLogo = styled(Link)`
  color: ${({ theme }) => theme.colors.light};
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: bold;
`;

const WebsiteRights = styled.small`
  color: ${({ theme }) => theme.colors.light};
  margin-bottom: 0.25rem;
  display: block;
`;

const ProductAttribution = styled.small`
  color: ${({ theme }) => theme.colors.light}CC;
  font-size: 0.9rem;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
`;

const SocialIconLink = styled.a`
  color: ${({ theme }) => theme.colors.light};
  font-size: 1.5rem;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    color: ${({ theme }) => theme.colors.highlight};
    transform: translateY(-3px);
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  
  svg {
    margin-right: 1rem;
    color: ${({ theme }) => theme.colors.highlight};
  }
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterLinksContainer>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Quick Links</FooterLinkTitle>
            <FooterLink to="/">Home</FooterLink>
            <FooterLink to="/booking">Book Appointment</FooterLink>
            <FooterLink to="/gallery">Gallery</FooterLink>
            <FooterLink to="/about">About Us</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
          </FooterLinkItems>
          
          <FooterLinkItems>
            <FooterLinkTitle>Contact Us</FooterLinkTitle>
            <ContactInfo>
              <FaMapMarkerAlt />
              <span>123 Tattoo St, Ink City</span>
            </ContactInfo>
            <ContactInfo>
              <FaPhone />
              <span>1-866-710-1801</span>
            </ContactInfo>
            <ContactInfo>
              <FaEnvelope />
              <span>admin@sonna.co</span>
            </ContactInfo>
          </FooterLinkItems>
          
          <FooterLinkItems>
            <FooterLinkTitle>Hours</FooterLinkTitle>
            <p>Monday - Friday: 10am - 8pm</p>
            <p>Saturday: 10am - 6pm</p>
            <p>Sunday: Closed</p>
          </FooterLinkItems>
        </FooterLinksWrapper>
      </FooterLinksContainer>
      
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to="/">Sonna</SocialLogo>
          <div>
            <WebsiteRights>Sonna © {new Date().getFullYear()} All rights reserved.</WebsiteRights>
            <ProductAttribution>Product of Dald Steel Inc.</ProductAttribution>
          </div>
          <SocialIcons>
            <SocialIconLink href="https://instagram.com" target="_blank" aria-label="Instagram">
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink href="https://facebook.com" target="_blank" aria-label="Facebook">
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href="https://twitter.com" target="_blank" aria-label="Twitter">
              <FaTwitter />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
};

export default Footer;
